<script setup>
import { Head, Link } from "@inertiajs/vue3";
import { useChatwoot } from "@/Composables/useChatwoot.js";

defineProps({
    title: {
        type: String,
        required: true,
    },
});

const { openChat } = useChatwoot();
</script>

<template>
  <Head>
    <title>{{ "besapro docs - " + title }}</title>
  </Head>

  <div class="min-h-screen bg-slate-50 text-slate-900">
    <header class="sticky top-0 z-40 border-b border-slate-200 bg-slate-50/90 backdrop-blur-sm">
      <div class="mx-auto flex h-16 max-w-(--breakpoint-2xl) items-center gap-6 px-6">
        <Link
          :href="route('marketing.docs.index')"
          class="text-sm font-semibold tracking-wide text-slate-700 uppercase hover:text-slate-900"
        >
          Documentatie
        </Link>

        <div class="flex flex-1 justify-end">
          <div class="w-full max-w-md">
            <slot name="search" />
          </div>
        </div>

        <nav class="hidden items-center gap-5 text-sm text-slate-600 lg:flex">
          <a
            :href="route('marketing.dashboard')"
            class="hover:text-slate-900"
          >
            Naar besapro.eu
          </a>
          <button
            type="button"
            class="rounded-md bg-slate-900 px-3 py-1.5 font-semibold text-white hover:bg-slate-700"
            @click="openChat"
          >
            Support
          </button>
        </nav>
      </div>
    </header>

    <main>
      <slot />
    </main>

    <footer class="border-t border-slate-200">
      <div class="mx-auto flex max-w-(--breakpoint-2xl) flex-col items-start justify-between gap-2 px-6 py-6 text-xs text-slate-500 sm:flex-row sm:items-center">
        <p>&copy; 2026 besapro.eu</p>
        <div class="flex gap-4">
          <a
            :href="route('marketing.privacy')"
            class="hover:text-slate-700"
          >Privacy</a>
          <a
            :href="route('marketing.terms')"
            class="hover:text-slate-700"
          >Voorwaarden</a>
        </div>
      </div>
    </footer>
  </div>
</template>
